import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '1',
  title: 'Identifica',
  description: 'Descubre qué órgano está sobrecargado según tu hora de desvelo.'
}, {
  number: '2',
  title: 'Presiona',
  description: 'Aplica la "Trinidad de la Calma" en los puntos de acupresión indicados.'
}, {
  number: '3',
  title: 'Desciende',
  description: 'Realiza la respiración sonora para bajar la energía de la cabeza a los pies.'
}];
export function HowItWorks() {
  return <section className="w-full bg-navy-800 px-4 py-20" data-id="element-79">
      <div className="max-w-5xl mx-auto" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-81">
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-82">
            Cómo Funciona
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto" data-id="element-83"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-84">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="text-center" data-id="element-85">
              <div className="w-20 h-20 rounded-full bg-gold text-navy-900 flex items-center justify-center mx-auto mb-6 font-serif text-3xl font-bold" data-id="element-86">
                {step.number}
              </div>
              <h3 className="font-serif text-2xl text-white mb-4" data-id="element-87">
                {step.title}
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-88">
                {step.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-89">
          <motion.a href="#oferta" whileHover={{
          scale: 1.05,
          boxShadow: '0 0 30px rgba(212, 175, 55, 0.5)'
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-gold text-navy-900 font-semibold px-8 py-4 rounded-lg text-lg transition-all duration-300 cursor-pointer" data-id="element-90">
            ¡QUIERO DORMIR BIEN AHORA!
          </motion.a>
        </motion.div>
      </div>
    </section>;
}